// extracted by mini-css-extract-plugin
module.exports = {"Divider":"MarketplaceItemData_Divider__1vdlF"};